import { UserRoleId } from '../app/enums/user-role.enum';

export const sharedEnvironment = {
    defaultLanguage: 'en',
    languageConfig: [
        {
            isDefault: true,
            value: 'ru',
            displayValue: 'Русский',
            icon: 'images/lang/RU.png',
        },
        {
            isDefault: false,
            value: 'en',
            displayValue: 'English',
            icon: 'images/lang/EN.png',
        },
        {
            isDefault: false,
            value: 'kk',
            displayValue: 'Қазақша',
            icon: 'images/lang/KZ.png',
        },
        {
            isDefault: false,
            value: 'ky',
            displayValue: 'Кыргызча',
            icon: 'images/lang/KG.png',
        },
        {
            isDefault: false,
            value: 'uz',
            displayValue: "O'zbekcha",
            icon: 'images/lang/UZ.png',
        },
        {
            isDefault: false,
            value: 'tg',
            displayValue: 'Тоҷикӣ',
            icon: 'images/lang/TJ.png',
        },
        {
            isDefault: false,
            value: 'az',
            displayValue: 'Azərbaycanca',
            icon: 'images/lang/AZ.png',
        },
        {
            isDefault: false,
            value: 'hy',
            displayValue: 'Հայերեն',
            icon: 'images/lang/AM.png',
        },
        {
            isDefault: false,
            value: 'ka',
            displayValue: 'ქართული',
            icon: 'images/lang/GE.png',
        },
    ],
    countrySelectEnabled: true,
    countryConfig: [
        {
            code: 'KZ',
            icon: 'images/countries/kazakhstan.png',
            phonePrefix: '+7',
            phoneFormat: {
                pattern: '^\\d{3} \\d{3} \\d{2} \\d{2}$',
                placeholder: 'XXX XXX XX XX',
                maxLength: 13,
                digitsCount: 10
            },
            isDefault: true,
            translations: {
                ru: 'Казахстан',
                en: 'Kazakhstan',
                kk: 'Қазақстан',
                ky: 'Казакстан',
                uz: 'Qozogʻiston',
                tg: 'Қазоқистон',
                az: 'Qazaxıstan',
                hy: 'Ղազախստան',
                ka: 'ყაზახეთი'
            },
            languages: ['kk', 'ru']
        },
        {
            code: 'KG',
            icon: 'images/countries/kyrgyzstan.png',
            phonePrefix: '+996',
            phoneFormat: {
                pattern: '^\\d{3} \\d{3} \\d{3}$',
                placeholder: 'XXX XXX XXX',
                maxLength: 11,
                digitsCount: 9
            },
            isDefault: false,
            translations: {
                ru: 'Кыргызстан',
                en: 'Kyrgyzstan',
                kk: 'Қырғызстан',
                ky: 'Кыргызстан',
                uz: 'Qirgʻiziston',
                tg: 'Қирғизистон',
                az: 'Qırğızıstan',
                hy: 'Ղրղզստան',
                ka: 'ყირგიზეთი'
            },
            languages: ['ky', 'ru']
        },
        {
            code: 'AM',
            icon: 'images/countries/armenia.png',
            phonePrefix: '+374',
            phoneFormat: {
                pattern: '^\\d{2} \\d{3} \\d{3}$',
                placeholder: 'XX XXX XXX',
                maxLength: 10,
                digitsCount: 8
            },
            isDefault: false,
            translations: {
                ru: 'Армения',
                en: 'Armenia',
                kk: 'Армения',
                ky: 'Армения',
                uz: 'Armaniston',
                tg: 'Арманистон',
                az: 'Ermənistan',
                hy: 'Հայաստان',
                ka: 'სომხეთი'
            },
            languages: ['hy', 'ru']
        },
        {
            code: 'AZ',
            icon: 'images/countries/azerbaijan.png',
            phonePrefix: '+994',
            phoneFormat: {
                pattern: '^\\d{2} \\d{3} \\d{2} \\d{2}$',
                placeholder: 'XX XXX XX XX',
                maxLength: 12,
                digitsCount: 9
            },
            isDefault: false,
            translations: {
                ru: 'Азербайджан',
                en: 'Azerbaijan',
                kk: 'Әзірбайжан',
                ky: 'Азербайжан',
                uz: 'Ozarbayjon',
                tg: 'Озарбойҷон',
                az: 'Azərbaycan',
                hy: 'Ադրբեջան',
                ka: 'აზერბაიჯანი'
            },
            languages: ['az', 'ru']
        },
        {
            code: 'UZ',
            icon: 'images/countries/uzbekistan.png',
            phonePrefix: '+998',
            phoneFormat: {
                pattern: '^\\d{2} \\d{3} \\d{2} \\d{2}$',
                placeholder: 'XX XXX XX XX',
                maxLength: 12,
                digitsCount: 9
            },
            isDefault: false,
            translations: {
                ru: 'Узбекистан',
                en: 'Uzbekistan',
                kk: 'Өзбекстан',
                ky: 'Өзбекстан',
                uz: 'Oʻzbekiston',
                tg: 'Ӯзбекистон',
                az: 'Özbəkistan',
                hy: 'Ուզբեկստան',
                ka: 'უზბეკეთი'
            },
            languages: ['uz', 'ru']
        },
    ],
    unconfirmedRoleId: UserRoleId.Unconfirmed,
    anonymousRoleId: UserRoleId.Anonymous,
    maxMonthWithdraw: 500000,
    autoGenSurveys: true,
    featureFlags: {
        friends: false,
        chat: false,
        tasks: true,
        dateTimeSendTimestamp: true,
        showOnboardingModal: false,
        changeUserData: false,
        addVisaCard: true,
        addMastercard: true,
        referralCode: false,
        addUzCard_MasterCard: true
    },
    ofertaUrl: '/oferta.pdf',
    translateRoute: '/i18n/',
};